import classNames from 'classnames';
import GloLayout from 'code-micro/common/GloLayoutA';
import { ContentServerProps } from 'code-micro/props/content';
import EcoButton from 'eco-design/base/eco-button';
import EcoImg from 'eco-design/base/eco-img';
import './index.scss';
import { BannerCom } from '../../index-banner-swiper/content/BannerCom';
export default function Content({ id, data = {}, initIndex = 0 }: ContentServerProps) {
    const { layout = 'two', list = [], autoPlay, tabLayout } = data;
    return (
        <GloLayout className={`editor-index-common-card`} id={id} data={data}>
            {layout === 'one' ? (
                <BannerCom
                    prefixCls="index-banner-swiper"
                    className="index-common-card-layout-swiper"
                    initIndex={initIndex}
                    autoPlay={autoPlay}
                    list={list}
                    tabLayout={tabLayout}
                />
            ) : (
                <div className={`index-common-card-list index-common-card-layout-${layout}`}>
                    {list.map((itemA: any, index: number) => {
                        const prefixCls = `index-common-card-item`;
                        const itemLayout = itemA.layout || 'default';
                        const itemTheme = itemA.theme || 'theme';
                        const classes = classNames(prefixCls, {
                            [`${prefixCls}-layout-${itemLayout}`]: itemLayout,
                            [`${prefixCls}-theme-${itemTheme}`]: itemTheme,
                        });
                        return (
                            <div className={classes} key={index}>
                                <EcoImg pc={itemA.pc} h5={itemA.h5} className={`${prefixCls}-img`} />
                                <div className={`${prefixCls}-msg`}>
                                    <div className={`${prefixCls}-info`}>
                                        <div className={`${prefixCls}-label`}>{itemA.label}</div>
                                        <div className={`${prefixCls}-title`}>{itemA.title}</div>
                                        <div className={`${prefixCls}-desc`}>{itemA.desc}</div>
                                        <div className={`${prefixCls}-box-btn`}>
                                            <EcoButton
                                                lTheme={itemA.theme}
                                                lType="text"
                                                lHref={itemA.lHref}
                                                lChildren={itemA.lBtnContent}
                                                lIsWithRightArrow={true}
                                            />
                                            <EcoButton
                                                lTheme={itemA.theme}
                                                lType="text"
                                                lHref={itemA.rHref}
                                                lChildren={itemA.rBtnContent}
                                                lIsWithRightArrow={true}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div>
            )}
        </GloLayout>
    );
}
